import api from "@/core/services/api.service";
class acrError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}


const acrService = {
    // lista de eventos asociados a la cuenta ✓
    async Events(params){
        try {
            api.setHeader();
            const response = await api.post("api/events", params);
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    //lista de formularios para acreditación segun el evento ✓
    async configForms(params){
        try {
            api.setHeader();
            const response = await api.post(`api/events/forms`, params);
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    //formulario de intencion de participación - get data ✓
    async getFip(id){
        try{
            api.setHeader();
            const response = await api.get("api/events/fip", id);
            return response;
        } catch(error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    //formulario de intencion de participación - save data ✓
    async saveFip(params){
        try {
            api.setHeader();
            const response = await api.post("api/events/fip", params);
            return response;
        } catch(error) {
            throw new acrError(error.response.status, error.response)
        }
    },
    async guardarItemNominal(params){
        try {
            api.setHeader();
            const response = await api.post("api/nominal/additem", params);
            return response;
        } catch(error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async listarNominal(params) {
        try {
            api.setHeader();
            const response = await api.post("api/nominal/list", params);
            return response;
        } catch(error) {
            throw new acrError(error.response.status, error.response)
        }
    },
    async deleteItem(params) {
        try {
            api.setHeader();
            const response = await api.post("api/nominal/deleteItem", params);
            return response;
        } catch(error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async finalizar(params) {
        try {
            api.setHeader();
            const response = await api.post("api/nominal/finalizar", params);
            return response;
        } catch(error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    

    //formulario entrada cuantitativo - get data
    getFeQ(id) {
        api.setHeader();
        return api.get("api/events/feq", id);
    },

    saveFeQ(form) {
        api.setHeader()
        return api.post("api/events/feq", form)
    },
    //lista de deportes asociados al evento ✓
    async Sports(params){
        try {
            api.setHeader();
            const response = await api.post(`api/events/sports`, params);
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    /*----------------------------------------------------------------------*/





    async configSport(params) {
        try {
            api.setHeader();
            const response = await  api.post(`api/${params.sport}/config`, params.data)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async delete(id) {
        try {
            api.setHeader();
            const response = await api.delete(`acr/delete/${id}`)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async edit(id) {
        try {
            api.setHeader();
            const response = await api.get("acr/edit", id)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async updateOfficer(params){
        try {
            api.setHeader();
            const response = await api.update("acr/officers/update", params.slug, params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async status(params) {
        try {
            api.setHeader();
            const response = await api.post("acr/status", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async typesFiles(params) {
        try {
            api.setHeader();
            const response = await api.post("acr/files/tipos", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async filesUploads(id) {
        try {
            api.setHeader();
            const response = await api.get("acr/files", id)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async Teams(params){
        try {
            api.setHeader();
            const response = await api.post("acr/teams", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async saveTeam(params){
        try {
            api.setHeader();
            const response = await api.post("acr/teams/save", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },
    async editTeam(id){
        try {
            api.setHeader();
            const response = await api.get("acr/teams/edit", id)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async captain(params){
        try {
            api.setHeader();
            const response = await api.post("acr/teams/captain", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async finish(params){
        try {
            api.setHeader();
            const response = await api.post("acr/finish", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    }
}

export default acrService
export { acrService, acrError }